import styled from '@emotion/styled';
import React from 'react';
import PropTypes from 'prop-types';
import { StyledH2 } from './_shared/styled-headings';
import { StyledSection } from './_shared/styled-section';
import { StyledP } from './_shared/styled-headings';
import { StyledTag } from './_shared/styled-headings';
import { flexCenter } from './_shared/styled-mixins';

const StyledBlock = styled(StyledSection)`
  background-color: var(--darkbg-color);
  width: 100%;
  display: flex;
  ${flexCenter};
  flex-direction: column;
  padding: 3rem 0;

  color: var(--darkbg-content-color);
  text-align: center;
  font-size: 0.8rem;
`;

const StyledContent = styled.div`
  width: 100%;
  padding: 4rem calc((var(--space) / 2));
  text-align: center;
  font-size: 0.8rem;
`;

const WhoCanJoin = ({ data }) => {
  const { summary } = data;

  return (
    <React.Fragment>
      <StyledBlock>
        <StyledContent>
          <StyledTag>Am I eligible to sign up?</StyledTag>
          <StyledH2>Any industry, any experience level</StyledH2>
          <StyledP dangerouslySetInnerHTML={{ __html: summary }} />
        </StyledContent>
      </StyledBlock>
    </React.Fragment>
  );
};

WhoCanJoin.propTypes = {
  data: PropTypes.object.isRequired,
};

export default WhoCanJoin;
